import FontUploadIcon from 'components/icons/font-upload-icon/index.vue'
import AnimationProcessing from 'components/animations/processing'
import FouExpand from 'components/tools/fou-expand/'
import { UploadObject } from 'src/utils/objects/uploader'

export default {
  name: 'uploader',

  components: {
    FouExpand,
    AnimationProcessing,
    FontUploadIcon,
  },

  data() {
    return {
      uploader: UploadObject()
    }
  },

  methods: {
    setUploader() {
      /**
       * Set uploader on target.
       * Pass handle to dispatch submits to binaries/upload in $store.
       * Results will be proceeded in results.vue.
       */
      const $0 = this
      if (this.$el.querySelector('#qq-uploader-zone')) {
        this.uploader.create({
          context: this,
          target: '#qq-uploader-zone',
          handle: function () {
            $0.$store
              .dispatch('binaries/upload', {
                id: $0.$store.getters['submissions/submission'].id,
                submits: $0.uploader.getSubmits()
              })
              .then(() => {
                $0.$events.$emit('validateFontPreview')
              })
          }
        })
      }
    }
  },

  mounted() {
    this.setUploader()
  },

  unmounted() {
    this.$store.commit('binaries/emptyUploadedFonts');
  },

  computed: {
    uploading() {
      return this.$store.getters['binaries/uploading']
    }
  },

  updated() {
    /*
     * Make sure the uploader is resetted in Template after render update.
     */
    this.setUploader()
  }
}
